const data = [
    {
        id: '1',
        title:"Media",
        imageWrapper:"img/project/project-1.png",
        category: "Media",
        details:"FOX+ APP",
        content1: 'Facing competition from the likes of Netflix’s launch in Asia, 10x worked with FOX to launch the initial version within 4 months and have since iteratively enhanced it into a world-class OTT product across the region.',
        content2: ' Today, the product boasts millions of users across 5 countries and continues to have a healthy growth rate.',
    },
    {
        id: '2',
        title:"Media",
        imageWrapper:"img/project/project-2.png",
        category: "Media",
        details:"DISNEY CHANNEL",
        content1: "Disney Channel - watch now is a streaming service which brings the best of the Disney Channel to a free app. With a library of shows, live watching, games and music videos all available to access at any time, this official Disney download brings together all the content a fan could want into one place."
    },
    {
        id: '3',
        title:"Media",
        imageWrapper:"img/project/project-3.png",
        category: "Media",
        details:"SINGTEL NEWSLOOP",
        content1: "Award-winning news and lifestyle content app built with Singtel.",
        content2: "Deployed in Singapore, Indonesia, Malaysia, Thailand, Philippines and Australia. Aggregates over 600 News Sources with over 3 Million Users."
    },
    // {
    //     id: '4',
    //     title:"HealthCare",
    //     imageWrapper:"img/project/project-4.png",
    //     category: "HealthCare",
    //     details:"THOMSON MEDICAL CENTRE APP",
    // },
    // {
    //     id: '5',
    //     title:"HealthCare",
    //     imageWrapper:"img/project/project-5.png",
    //     category: "HealthCare",
    //     details:"NHG - LEAP",
    // },
    // {
    //     id: '6',
    //     title:"HealthCare",
    //     imageWrapper:"img/project/project-6.png",
    //     category: "HealthCare",
    //     details:"TTSH - eComs",
    // },
    // {
    //     id: '7',
    //     title:"BFIS",
    //     imageWrapper:"img/project/project-7.png",
    //     category: "BFIS",
    //     details:"BNP Paribas: The Pitchbook",
    // },
    // {
    //     id: '8',
    //     title:"BFIS",
    //     imageWrapper:"img/project/project-8.png",
    //     category: "BFIS",
    //     details:"DBS iTravel",
    // },
    // {
    //     id: '9',
    //     title:"BFIS",
    //     imageWrapper:"img/project/project-9.png",
    //     category: "BFIS",
    //     details:"NTUC INCOME PINFARE",
    // },
    // {
    //     id: '10',
    //     title:"AI",
    //     imageWrapper:"img/project/project-10.png",
    //     category: "Blockchain",
    //     details:"HUGGIES VIETNAM",
    // },
    // {
    //     id: '11',
    //     title:"AI",
    //     imageWrapper:"img/project/project-11.png",
    //     category: "Blockchain",
    //     details:"MELCO RESORT",
    // },
    // {
    //     id: '12',
    //     title:"AI",
    //     imageWrapper:"img/project/project-12.png",
    //     category: "Blockchain",
    //     details:"Sacombank Chatbot",
    // },
    {
        id: '13',
        title:"Blockchain",
        imageWrapper:"img/project/project-13.png",
        category: "Blockchain",
        details:"Life On Mars",
    },
    {
        id: '14',
        title:"Blockchain",
        imageWrapper:"img/project/project-14.png",
        category: "Blockchain",
        details:"DEFILY",
        content1: "Defily is the first-ever cross-chain Decentralized Finance project on KardiaChain, which bridge to Binance Smart Chain and planning to bridge to Harmony, Avalanche, and Tomochain in the near future. Defily focuses on bringing DeFi to everyone in a fun and an easy to understand way!",
    },
    {
        id: '15',
        title:"Blockchain",
        imageWrapper:"img/project/project-15.png",
        category: "Blockchain",
        details:"DRAGON WAR",
        content1: "Dragon War is a decentralized NFT blockchain game with Play-To-Earn concept on KardianChain. You can earn DRAGON tokens by playing game then use them to swap, upgrade your team or breed new dragons.",
    },
];

export default data;